var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGeneralIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10658_2391)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.843 1.47514L11.9091 5.40906L12.4394 8.06071L15.0911 8.59104L19.025 4.65712C19.5119 5.80653 19.6288 7.07897 19.3585 8.29766C19.0883 9.51635 18.4449 10.6205 17.5177 11.4563C16.5906 12.2922 15.426 12.8182 14.1859 12.9611C12.9458 13.1041 11.692 12.8569 10.599 12.2539L5.34106 18.341C4.91902 18.7626 4.34686 18.9993 3.75034 18.9991C3.15382 18.999 2.58179 18.7619 2.15999 18.3401C1.73819 17.9183 1.50115 17.3463 1.50098 16.7498C1.50081 16.1533 1.73753 15.5811 2.15908 15.1591L8.2464 9.90105C7.6434 8.80806 7.39603 7.55434 7.53897 6.31426C7.68192 5.07419 8.20793 3.90953 9.04379 2.9824C9.87965 2.05528 10.9838 1.41182 12.2025 1.1416C13.4212 0.871373 14.6936 0.988218 15.843 1.47514Z",
    stroke: "#42296E",
    strokeWidth: 1.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10658_2391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralIcon);
export default __webpack_public_path__ + "static/media/generalIcon.9b16b424f28cc02617ba9a0ba6c19817.svg";
export { ForwardRef as ReactComponent };